/**
 * 综合处理
 */
export default {
  methods: {
    /**
     * 场景一：2.2.14.14对其它字段进行赋值（定制服务）(见docs下同名文件)
     * Demo：
     *   配置：{"webconf":{"formRequest":{"refcolumn":"A,B,C","method":"fn_AAA"}}}
     */
    async fn_AAA(x) {
      // debugger
      return [
        {
          "COLUMN_NAME": "LOGISTICS_NUMBER",
          "COLUMN_TYPE": 1,
          "LABLE_VALUES": [
            {
              "LABLE": null, // 是描述
              "VALUE": 'testtest'  // 数据的值
            }
          ]
        }
      ]
    },
  },
};
